(function () {
  function getContactPayload(form, shell) {
    const formData = new FormData(form);
    const contact = {};

    formData.forEach((value, key) => {
      const match = key.match(/^contact\[(.+)\]$/);
      if (match) {
        contact[match[1]] = value;
      }
    });

    return {
      source: shell.dataset.crmSource || document.title,
      page_url: window.location.href,
      submitted_at: new Date().toISOString(),
      contact
    };
  }

  function setStatus(status, message, state) {
    if (!status) {
      return;
    }

    status.textContent = message;
    status.hidden = false;
    status.classList.remove("is-success", "is-error");
    status.classList.add(state === "success" ? "is-success" : "is-error");
  }

  function bindForms(root) {
    root.querySelectorAll(".nova-crm-form").forEach((form) => {
      if (form.dataset.crmBound === "true") {
        return;
      }

      const shell = form.closest(".nova-contact-form");
      const endpoint = shell && shell.dataset.crmEndpoint ? shell.dataset.crmEndpoint.trim() : "";

      form.dataset.crmBound = "true";

      form.addEventListener("submit", async (event) => {
        event.preventDefault();

        const submitButton = form.querySelector('button[type="submit"]');
        const status = form.querySelector("[data-crm-status]");
        const successMessage = shell.dataset.crmSuccess || "Thanks. We will get back to you shortly.";
        const errorMessage = shell.dataset.crmError || "We could not submit the form. Please try again.";

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute("aria-busy", "true");
        }

        try {
          const response = endpoint
            ? await fetch(endpoint, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                credentials: "omit",
                body: JSON.stringify(getContactPayload(form, shell))
              })
            : await fetch(form.action, {
                method: form.method || "POST",
                body: new FormData(form),
                credentials: "same-origin"
              });

          if (!response.ok) {
            throw new Error("CRM request failed");
          }

          form.reset();
          setStatus(status, successMessage, "success");
        } catch (error) {
          setStatus(status, errorMessage, "error");
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute("aria-busy");
          }
        }
      });
    });
  }

  bindForms(document);

  document.addEventListener("shopify:section:load", (event) => {
    bindForms(event.target);
  });
})();
